<template>
  <div class="w-full h-full">
    <!-- 顶部 Banner：标题淡入 -->
    <div class="relative w-full h-[300px] sm:h-[400px] md:h-[600px] lg:h-[800px]">
      <img
        src="../../assets/img/lianxi_1.webp"
        alt="service-banner"
        class="w-full object-cover h-full"
      />
      <div class="absolute bottom-0 left-0 right-0 text-white text-[32px] sm:text-[48px] md:text-[60px] lg:text-[72px] font-bold container mx-auto flex flex-col items-start justify-center px-4 sm:px-6 scroll-fade-in">
        <div>联系我们</div>
        <div class="text-[20px] sm:text-[28px] md:text-[36px] lg:text-[48px] -mt-[8px] sm:-mt-[12px] md:-mt-[16px] lg:-mt-[20px] mb-4 sm:mb-6 md:mb-8 lg:mb-10">CONTACT US</div>
      </div>
    </div>
    <div class=" w-full h-auto  bg-[#04193B] lg:pb-[79px] pb-6 lg:pt-[56px]  pt-6">

      <img
        src="../../assets/img/hezuo.webp"
        alt="service-banner"
        class=" mx-auto scroll-fade-in mb-6 lg:mb-[46px]"
      />
      <!-- 表单 -->
      <div class="w-full mx-auto px-4 sm:px-6 md:px-8">
        <div class="w-full max-w-[1400px] mx-auto">
          <CooperationForm />
        </div>
      </div>
    </div>
    <div class="w-full relative">
      <!-- 背景图 -->
      <div class="absolute inset-0 w-full h-full">
        <img
          :src="homeBottomImg"
          alt="contactUs"
          class="w-full h-full object-cover"
        />
      </div>

      <!-- 内容层 -->
      <div class="relative z-10 flex flex-col items-center justify-center py-8 sm:py-12 md:py-16 lg:py-20 px-4 sm:px-6 min-h-[600px] sm:min-h-[700px] md:min-h-[800px]">
        <!-- 中间：线下体验 Contact US -->
        <img
          :src="contactImg"
          alt="home_bottom_center"
          class="h-auto w-[90%] sm:w-auto scroll-fade-in max-w-[80px] sm:max-w-[100px] md:max-w-[122px] lg:max-w-[144px] mb-6 sm:mb-8 md:mb-10"
        >

        <div class="text-white text-[12px] sm:text-[14px] md:text-[16px] lg:text-[20px] xl:text-[24px] font-[w400] text-center mb-6 sm:mb-8 md:mb-10 px-4 leading-relaxed scroll-fade-in">
          如需了解 XR 家装、剧场内容定制细节，或探讨技术合作。<br />
          可通过以下方式与我们取得联系：添加企业微信；拨打客服电话：130 5258 5965<br />
          工作日 9:00-18:00 有技术顾问实时解答；<br />
          可到现场近距离体验XR技术带来的极致体验。<br />
          我们以数据化响应流程确保高效对接，让每一次沟通都精准触达需求核心。
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-[50px] items-start md:items-center justify-center mt-4 sm:mt-6 md:mt-[50px] w-full max-w-[1400px]">
          <!-- 左侧联系信息 -->
          <div class="flex flex-col gap-4 sm:gap-5 md:gap-6 w-full scroll-fade-in-left">
            <!-- 联系电话 -->
            <div class="flex flex-col">
              <div class="text-white text-[14px] sm:text-[16px] md:text-[20px] lg:text-[22px] mb-2 font-normal">联系电话:</div>
              <a
                href="tel:13052585965"
                class="text-white text-[18px] sm:text-[20px] md:text-[24px] lg:text-[28px] font-bold hover:opacity-80 transition-opacity"
              >130 5258 5965</a>
            </div>

            <!-- 联系地址 -->
            <div class="flex flex-col">
              <div class="text-white text-[14px] sm:text-[16px] md:text-[20px] lg:text-[22px] mb-2 font-normal">联系地址:</div>
              <div class="text-white text-[16px] sm:text-[18px] md:text-[22px] lg:text-[28px] font-bold leading-tight break-words">上海市闵行区万芳路515号A座8层</div>
            </div>

            <!-- 二维码 -->
            <div class="flex flex-row gap-4 sm:gap-5 md:gap-6 mt-4 sm:mt-5 justify-center md:justify-start">
              <div class="flex flex-col items-center">
                <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[120px] md:h-[120px] lg:w-[140px] lg:h-[140px] bg-white rounded-lg mb-2 flex items-center justify-center shadow-md">
                  <img
                    :src="productCodeImg"
                    alt="产品支持二维码"
                    class="w-full h-full object-contain"
                  />
                </div>
                <div class="text-white text-[12px] sm:text-[14px] md:text-[18px] lg:text-[22px] font-bold">产品支持</div>
              </div>
              <div class="flex flex-col items-center">
                <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[120px] md:h-[120px] lg:w-[140px] lg:h-[140px] bg-white rounded-lg mb-2 flex items-center justify-center shadow-md">
                  <img
                    :src="coopCodeImg"
                    alt="合作咨询二维码"
                    class="w-full h-full object-contain"
                  />
                </div>
                <div class="text-white text-[12px] sm:text-[14px] md:text-[18px] lg:text-[22px] font-bold">合作咨询</div>
              </div>
            </div>
          </div>

          <!-- 右侧：地图和地址 -->
          <div class="flex flex-col gap-4 w-full scroll-fade-in-right title-family-normal">
            <!-- 地图容器 -->
            <div class="w-full max-w-[600px] mx-auto h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] bg-white rounded-lg overflow-hidden shadow-lg relative">
              <!-- 使用高德地图组件 -->
              <AmapMap
                :longitude="121.404"
                :latitude="31.081"
                address="上海市闵行区 万芳路515号"
                :zoom="16"
                :height="'100%'"
                :show-marker="true"
                marker-title="易目秀信息科技(上海)有限公司"
              />
              <!-- 地图上的地址标记 -->
              <div class="absolute bottom-0 left-0 right-0 bg-[#333333]/20 backdrop-blur-md text-black text-[12px] sm:text-[14px] md:text-[18px] lg:text-[24px] px-2 sm:px-[29px] py-1.5 sm:py-4 text-left z-10 font-bold">
                上海市闵行区万芳路515号A座8层
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";
import AmapMap from "@/components/AmapMap.vue";
import homeBottomImg from "@/assets/img/ty_bg.webp";
import contactImg from "@/assets/img/lianxi_white.webp";
import productCodeImg from "@/assets/img/product-code.webp";
import coopCodeImg from "@/assets/img/coop-code.webp";
import CooperationForm from "@/components/CooperationForm.vue";

// 滚动动画：与其它页面统一的 fade-in 系统
const animatedElements = new Set<HTMLElement>();

const observerOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1,
};

let observer: IntersectionObserver | null = null;

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        const el = entry.target as HTMLElement;
        el.classList.add("fade-in-visible");
        animatedElements.add(el);
      }
    });
  }, observerOptions);

  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((el) => observer?.observe(el));
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
.title-family-normal {
  font-family: "Noto Sans SC";
}
/* 滚动动画：自下而上淡入 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 滚动动画：从左侧滑入（预留，当前主要用在卡片区） */
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-40px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 滚动动画：从右侧滑入（预留） */
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(40px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

.input-wrapper {
  position: relative;
}

.input-wrapper::before {
  content: "";
  position: absolute;
  top: 2px;
  /* 跳过 label 的高度（text-sm + mb-2 ≈ 2.5rem） */
  left: 0;
  width: 2px;
  bottom: 2px;
  /* 与底部边框对齐 */
  background: linear-gradient(180deg, #4a90e2, #4a90e2);
  pointer-events: none;
  border-radius: 2rem;
}

.input-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #4a90e2, #f161f9);
  opacity: 1;
  pointer-events: none;
  border-radius: 0 0 2rem 2rem;
}
</style>